import React from "react";
import './App.css';
import {Link} from "react-router-dom";

const Header = () => {
    return (
        <header className="HeaderBox">
          <nav className="Navigation">
            <a href="#landing" rel="noopener noreferrer">Home</a>
            <a href="#about" rel="noopener noreferrer">About</a>
            <a href="http://emichris.github.io"rel="noopener noreferrer">Home</a>
            <a href="#mainsection" rel="noopener noreferrer">Predictor</a>
            <a href="#footer" rel="noopener noreferrer">Contact</a>
          </nav>
        </header>
        )};

export default Header;